import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/api-response.model';
import { PaginatedResponse } from '../../models/paginated-response';
import { IndustryType, UpsertIndustryTypeRequest } from '../../models/industry-type.model';

@Injectable({ providedIn: 'root' })
export class IndustryTypeService {
    private readonly apiUrl = `${environment.apiGatewayBaseUrl}/Companies`;

    constructor(private http: HttpClient) { }

    getIndustryTypesPaginated(
        pageNumber: number,
        pageSize: number,
    ): Observable<PaginatedResponse<IndustryType>> {
        const params = new HttpParams()
            .set('pageNumber', pageNumber)
            .set('pageSize', pageSize);
        return this.http.get<PaginatedResponse<IndustryType>>(`${this.apiUrl}/industry-types-paginated`, { params });
    }

    upsertIndustryType(payload: UpsertIndustryTypeRequest): Observable<ApiResponse<boolean>> {
        return this.http.post<ApiResponse<boolean>>(`${this.apiUrl}/upsert-industry-type`, payload);
    }
}